import {Component, Input} from '@angular/core';
import {IonImg} from "@ionic/angular/standalone";
import {RouterLink} from '@angular/router';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'app-post-card',
  imports: [
    IonImg,
    RouterLink,
    DatePipe
  ],
    templateUrl: './post-card.component.html',
    styleUrl: './post-card.component.scss'
})
export class PostCardComponent {
  @Input() height: string = '';
  @Input() post: any;

}
